// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + "." + {"265":"480f2dbe","297":"12b24e66","643":"188116f2","787":"14c43a21"}[chunkId] + ".chunk.js";
};